import React from 'react';
import PageHeader from '../ui/PageHeader';
import StepCard, { InfoTile, LinkTile } from '../ui/StepCard';
import ContractRow from '../ui/ContractRow';
import Seo from '../ui/Seo';
import BuyCard from '../ui/BuyCard';
import { CONTRACTS } from '../../data/site';

const chain = CONTRACTS.arbitrum;

const ArbBuyPage = () => (
  <main className="wrap">
    <Seo title="Buy $BOOP on Arbitrum" description="Step-by-step: buy $BOOP on Arbitrum with OpenOcean or CamelotDex." path="/buy/arbitrum" />
    <PageHeader back={{ to: '/buy', label: 'Back to options' }} eyebrow="🔵 ARBITRUM · ERC-20" title="How to buy $BOOP on" highlight="Arbitrum" />

    <div className="grid items-start gap-6 pt-7 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] lg:gap-10 lg:pt-12">
      <ol className="grid gap-4 lg:gap-5">
        <StepCard n={1} title="Load your swap tool of choice">
          <p>
            OpenOcean is a DEX aggregator: it offers the best price by combining liquidity from multiple providers (CamelotDex, Uniswap, SushiSwap,
            GammaSwap, etc.).
          </p>
          <div className="grid gap-3 sm:grid-cols-2">
            <LinkTile href="https://app.openocean.finance" title="OpenOcean" sub="DEX Aggregator" />
            <LinkTile href="https://app.camelot.exchange" title="CamelotDex" sub="Native DEX" />
          </div>
        </StepCard>
        <StepCard n={2} title="Connect your wallet">
          <p>Any EVM compatible wallet will work. Make sure the wallet supports the Arbitrum network.</p>
          <div className="grid gap-3 sm:grid-cols-2">
            <InfoTile title="MetaMask" sub="Most popular wallet" />
            <InfoTile title="WalletConnect" sub="Use any wallet" />
          </div>
          <p className="font-semibold">Make sure you have $ETH on Arbitrum in your wallet to execute the trade.</p>
          <p className="text-sm text-muted">If not, withdraw some from a CEX or buy directly from your wallet interface.</p>
        </StepCard>
        <StepCard n={3} title="Set up your trade">
          <p>
            <b>FROM:</b> select your source currency (e.g. ETH)
          </p>
          <p>
            <b>TO:</b> select BOOP
          </p>
          <p className="text-sm text-muted">If you use a swap interface where BOOP is not yet verified, paste the contract address below manually.</p>
        </StepCard>
        <StepCard n={4} title="Execute the trade">
          <p>Once the platform gives you a quote, execute the trade. Welcome to the pack!</p>
        </StepCard>

        <li className="card !bg-sun">
          <h3 className="text-xl font-bold">BOOP contract address</h3>
          <p className="mb-3 text-sm font-medium">Always verify the contract address before making any transaction.</p>
          <ContractRow chain={chain} showExplorer />
        </li>
      </ol>

      <aside className="lg:sticky lg:top-24">
        <p className="mb-3 text-[15px] font-medium">Skip the steps: Relay opens with $BOOP on Arbitrum already selected.</p>
        <BuyCard initialChain="arbitrum" />
      </aside>
    </div>
  </main>
);

export default ArbBuyPage;
